<div class="flex-row gap-10">
  <div class="flex-column flex-grow left">
    <mat-form-field class="form-column">
      <mat-label>Street</mat-label>
      <input
        matInput
        placeholder="Street"
        [disabled]="!editMode"
        [(ngModel)]="address.street"
        name="street"
        id="address.street" />
    </mat-form-field>

    <mat-form-field class="form-column">
      <mat-label>Street number</mat-label>
      <input
        matInput
        placeholder="Street number"
        [disabled]="!editMode"
        [(ngModel)]="address.streetNumber"
        name="streetNumber"
        id="address.streetNumber" />
    </mat-form-field>

    <mat-form-field class="form-column">
      <mat-label>Zip code</mat-label>
      <input
        matInput
        placeholder="Zip code"
        [disabled]="!editMode"
        [(ngModel)]="address.zipCode"
        name="zipCode"
        id="address.zipCode" />
    </mat-form-field>
  </div>
  <div class="flex-column flex-grow left">
    <mat-form-field class="form-column">
      <mat-label>City</mat-label>
      <input
        matInput
        placeholder="City"
        [disabled]="!editMode"
        [(ngModel)]="address.city"
        name="city"
        id="address.city" />
    </mat-form-field>

    <mat-form-field class="form-column">
      <mat-label>State or Province</mat-label>
      <input
        matInput
        placeholder="State or Province"
        [disabled]="!editMode"
        [(ngModel)]="address.stateOrProvince"
        name="stateOrProvince"
        id="address.stateOrProvince" />
    </mat-form-field>

    <mat-form-field class="form-column">
      <mat-label>Country</mat-label>
      <input
        matInput
        placeholder="Country code"
        [disabled]="!editMode"
        [(ngModel)]="address.country"
        name="country"
        id="address.country" />
    </mat-form-field>
  </div>
  @if (address.coordinates) {
    <div class="flex-column right">
      <mat-form-field class="form-column">
        <mat-label>Longitude</mat-label>
        <input
          matInput
          [disabled]="true"
          [(ngModel)]="address.coordinates[0]"
          name="longitude"
          id="address.coordinates.longitude" />
      </mat-form-field>
      <mat-form-field class="form-column">
        <mat-label>Latitude</mat-label>
        <input
          matInput
          [disabled]="true"
          [(ngModel)]="address.coordinates[1]"
          name="latitude"
          id="address.coordinates.latitude" />
      </mat-form-field>
    </div>
  }
</div>
